import axios from 'axios';

const API_BASE = '/api/membership-invoice';

export const getInvoices = (params) => axios.get(API_BASE, { params });
export const getInvoiceById = (id) => axios.get(`${API_BASE}/${id}`);
export const generateInvoice = (data) => axios.post(`${API_BASE}/generate`, data);
export const sendInvoiceEmail = (id) => axios.post(`${API_BASE}/${id}/send-email`);
export const downloadInvoicePdf = (id) => axios.get(`${API_BASE}/${id}/pdf`, { responseType: 'blob' }); 
export const markInvoiceAsPaid = (id, paymentDetails) => 
  axios.post(`${API_BASE}/${id}/mark-paid`, paymentDetails);

export const getInvoicePeriodsByProject = (projectId) => 
  axios.get(`${API_BASE}/get-invoice-periods/${projectId}`);

// Additional useful API calls
export const updateInvoiceStatus = (id, status) => 
  axios.patch(`${API_BASE}/${id}/status`, { status });

export const addPaymentToInvoice = (id, paymentData) => 
  axios.post(`${API_BASE}/${id}/payments`, paymentData);

export const getInvoicePayments = (id) => 
  axios.get(`${API_BASE}/${id}/payments`);

export const getInvoicePdfPreviewHtml = (id) => 
  axios.get(`${API_BASE}/${id}/invoice-pdf-preview`);

export const getInvoiceByPeriod = (projectId, startDate, endDate) => 
  axios.get(`${API_BASE}/get-invoice/by-period`, {
    params: { projectId, startDate, endDate }
  });